// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Hierarchy2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Hierarchy2/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9 5h7M2 5.25a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0ZM16 5a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM16 19a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM9 5.13c1.75.45 3.05 2.05 3.04 3.94l-.01 3.43a5.989 5.989 0 0 0 4.01 5.67"
}));
export default Hierarchy2Icon;